<div #teacherModal class="modal fade subject-management-create-teacher-modal subject-management-create-teacher-management-modal"
  tabindex="-1"
  aria-labelledby="subject-management-create-teacher-modal-title" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered subject-management-create-teacher-modal-dialog">
    <div class="modal-content subject-management-create-teacher-modal-content">
      <div class="subject-management-create-teacher-modal-header">
        <h5 id="subject-management-create-teacher-modal-title">จัดการผู้สอน</h5>
        <button type="button" class="subject-management-create-teacher-modal-close" aria-label="ปิด"
          (click)="cancelTeachers.emit()">
          &times;
        </button>
      </div>

      <form [formGroup]="teacherModalForm">
        <div class="subject-management-create-teacher-modal-body">
          <div class="subject-management-create-workload-mode">
            <div class="subject-management-create-workload-title">การคิดภาระงานสอน (ชั่วโมง)</div>
            <label class="subject-management-create-radio-option">
              <input type="radio" formControlName="workloadMode" value="shared" [disabled]="!workloadModeEditable" />
              <span>แบ่งภาระงาน</span>
            </label>
            <label class="subject-management-create-radio-option">
              <input type="radio" formControlName="workloadMode" value="notShared" [disabled]="!workloadModeEditable" />
              <span>ไม่แบ่งภาระงาน</span>
            </label>
          </div>

          <div class="subject-management-create-teacher-modal-toolbar">
            <button type="button"
              class="app-button app-button-outline subject-management-create-outline-button subject-management-create-modal-add-teacher-button"
              (click)="addTeacher.emit()">
              <span class="app-button-icon subject-management-create-outline-button-icon" aria-hidden="true">+</span>
              เพิ่มผู้สอน
            </button>
          </div>

          <div class="alert alert-warning py-2 px-3 mb-3" *ngIf="errorMessage">
            {{ errorMessage }}
          </div>

          <div class="subject-management-create-teacher-modal-table-wrap" formArrayName="teachers">
            <table class="subject-management-create-teacher-modal-table">
              <colgroup>
                <col class="subject-management-create-teacher-col-index" />
                <col class="subject-management-create-teacher-col-name" />
                <col class="subject-management-create-teacher-col-department" />
                <col class="subject-management-create-teacher-col-status" />
                <col class="subject-management-create-teacher-col-range" />
                <col class="subject-management-create-teacher-col-hours" />
                <col class="subject-management-create-teacher-col-action" />
              </colgroup>
              <thead>
                <tr>
                  <th>ลำดับ</th>
                  <th>ชื่อ - นามสกุล</th>
                  <th>สาขาวิชา</th>
                  <th>สถานะ</th>
                  <th>ช่วงวันที่สอน</th>
                  <th>ชั่วโมงที่สอน</th>
                  <th>จัดการ</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let teacherRow of teacherDraftRows.controls; let teacherIndex = index"
                  [formGroupName]="teacherIndex">
                  <td>{{ teacherIndex + 1 }}</td>
                  <td>
                    <app-select formControlName="userId" [options]="getAvailableTeacherOptions(teacherIndex)"
                      bindLabel="fullName" bindValue="id" [searchable]="true" [clearable]="true"
                      [isDisabled]="!isTeacherRowEditable(teacherIndex)"
                      [selectOptionOnPointerDown]="true"
                      inputClass="subject-management-create-select subject-management-create-teacher-name-select"
                      appendTo=".subject-management-create-teacher-management-modal" classes="mb-0"
                      (valueChange)="onTeacherSelected(teacherIndex, $event)"></app-select>
	                  </td>
	                  <td>{{ teacherRow.get('department')?.value || '-' }}</td>
                  <td>
                    <app-subject-management-status-badge
                      [label]="getTeacherStatusLabel(teacherIndex)"
                      [status]="getTeacherStatusType(teacherIndex)"
                    ></app-subject-management-status-badge>
                  </td>
	                  <td>
                    <div class="subject-management-create-teaching-range-cell">
                      <app-select formControlName="teachingRange"
                        [options]="getAvailableTeacherTeachingRangeOptions(teacherIndex)" bindLabel="label"
                        bindValue="value" [isMultiple]="true" [showSelectAll]="true" [multilineOption]="true"
                        [closeOnSelect]="false" [clearable]="true" [searchable]="false"
                        [isDisabled]="!isTeacherRowEditable(teacherIndex)"
                        appendTo=".subject-management-create-teacher-management-modal"
                        inputClass="subject-management-create-select subject-management-create-teaching-range-select"
                        classes="mb-0"></app-select>
                    </div>
                  </td>
                  <td>{{ getTeacherWorkloadHours(teacherIndex) }}</td>
                  <td>
                    <button type="button"
                      class="app-button app-button-icon-only subject-management-create-remove-time-button"
                      aria-label="ลบผู้สอน" [disabled]="!isTeacherRowEditable(teacherIndex)"
                      [attr.title]="isTeacherRowEditable(teacherIndex) ? null : 'สถานะปัจจุบันไม่อนุญาตให้แก้ไข'"
                      (click)="removeTeacher.emit(teacherIndex)">
                      <img src="assets/media/icons/svg/trush.svg" alt="" aria-hidden="true" />
                    </button>
                  </td>
                </tr>
                <tr *ngIf="teacherDraftRows.length === 0">
                  <td colspan="7" class="subject-management-create-empty">No data available in table</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="subject-management-create-teacher-modal-footer">
          <button type="button" class="app-button subject-management-create-teacher-modal-cancel"
            (click)="cancelTeachers.emit()">
            ยกเลิก
          </button>
          <button type="button" class="app-button app-button-primary subject-management-create-teacher-modal-save"
            (click)="saveTeachers.emit()">
            บันทึก
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
